export const stripTrailingSlash = (url: string): string =>
  url.replace(/\/+$/, "");

/**
 * Safely joins a base URL with one or more path segments, ensuring no double slashes.
 * Trailing slashes on the base and leading slashes on each segment are normalized.
 */
export const joinUrl = (base: string, ...paths: string[]): string => {
  const normalizedBase = stripTrailingSlash(base.trim());
  const normalizedPaths = paths.map((p) => p.replace(/^\/+/, "").trim());
  return [normalizedBase, ...normalizedPaths].join("/");
};

export const normalizeHttpUrl = (url: string): string => {
  const trimmed = url.trim();
  const withProtocol =
    trimmed.startsWith("http://") || trimmed.startsWith("https://")
      ? trimmed
      : `http://${trimmed}`;
  return stripTrailingSlash(withProtocol);
};

export const normalizeWsUrl = (url: string): string => {
  const trimmed = url.trim();
  let wsUrl: string;

  if (trimmed.startsWith("ws://") || trimmed.startsWith("wss://")) {
    wsUrl = trimmed;
  } else if (trimmed.startsWith("https://")) {
    wsUrl = `wss://${trimmed.replace(/^https:\/\//, "")}`;
  } else {
    wsUrl = `ws://${trimmed.replace(/^http:\/\//, "")}`;
  }

  const withoutTrailingSlash = stripTrailingSlash(wsUrl);
  return withoutTrailingSlash.endsWith("/ws")
    ? withoutTrailingSlash
    : `${withoutTrailingSlash}/ws`;
};
